/* eslint-disable consistent-return,max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// @material-ui/core components
import FilterStyles from 'assets/jss/AdsFilter';
import withStyles from '@material-ui/core/styles/withStyles';
import TextField from '@material-ui/core/TextField';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';

/**
 * @class
 * @extends React.Component
 */
class NotificationCategoryFilter extends React.Component {
  constructor(props) {
    super(props);
    const { appliedFilter } = props;
    this.state = {
      id: (appliedFilter && appliedFilter.id) || '',
      name: (appliedFilter && appliedFilter.name) || '',
      localFilter: appliedFilter || null,
    };
  }

  /**
   * @description
   * Change filters.
   *
   * @param {Object} changedFilter - Changed filters values.
   * @returns {*} - No returns value.
   */
  handleChangeFilter = changedFilter => {
    const { localFilter } = this.state;
    const { filter } = this.props;
    const filters = { ...localFilter, ...changedFilter };
    this.setState({ localFilter: filters });
    filter(filters);
  };

  /**
   * @description
   * Handle change in id filter.
   *
   * @param {Object} event - Input change event.
   * @returns {undefined} No return.
   */
  handleIdChange = event => {
    const id = event.target.value;
    this.setState({ id });
    this.handleChangeFilter({ id: id || undefined });
  };

  /**
   * @description
   * Handle change in name filter.
   *
   * @param {Object} event - Input change event.
   * @returns {undefined} No return.
   */
  handleNameChange = event => {
    const name = event.target.value;
    this.setState({ name });
    this.handleChangeFilter({ name: name || undefined });
  };

  /**
   * @description
   * Clear all filters.
   *
   * @returns {undefined} No return.
   */
  handleClearFilter = () => {
    const { filter } = this.props;
    this.setState({
      id: '',
      name: '',
      localFilter: null,
    });
    filter({});
  };

  /**
   * @description
   * Render component.
   *
   * @returns {*} Component to render.
   */
  render() {
    const { classes, t } = this.props;
    const { id, name } = this.state;

    return (
      <GridContainer>
        <GridItem xs={12} sm={6} md={4}>
          <TextField
            id="filter-id"
            label={t('notificationCategory.id')}
            fullWidth
            value={id}
            onChange={this.handleIdChange}
            className={classes.textField}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={4}>
          <TextField
            id="filter-name"
            label={t('notificationCategory.name')}
            fullWidth
            value={name}
            onChange={this.handleNameChange}
            className={classes.textField}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={4}>
          <Button
            color="white"
            onClick={this.handleClearFilter}
            className={classes.clearButton}
          >
            {t('common.clearFilters')}
          </Button>
        </GridItem>
      </GridContainer>
    );
  }
}

/**
 * NotificationCategoryFilter PropTypes
 */
NotificationCategoryFilter.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
  filter: PropTypes.func.isRequired,
  appliedFilter: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
};

NotificationCategoryFilter.defaultProps = {
  appliedFilter: null,
};

export default withTranslation()(
  withStyles(FilterStyles)(NotificationCategoryFilter),
);
